import '../../../App.css'
import { useEffect, useState } from 'react';
import { Table, Input, Select, Pagination } from 'antd';
import axios from 'axios';
import moment from "moment";
import Appconfig from '../../../config/config'
import 'react-notifications/lib/notifications.css';
import 'react-datepicker/dist/react-datepicker.css';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import TextField from '@mui/material/TextField';
import { DatePicker, Button } from 'antd';
import dayjs from 'dayjs';

function AccountStatement({ user_id }) {
    const userInfo = JSON.parse(localStorage.getItem('userdata'))
    const { RangePicker } = DatePicker;

    // Default: from_date = 7 days ago at 11:59, to_date = today at 11:59
    const defaultFrom = moment().subtract(7, 'days').set({ hour: 11, minute: 59 }).toDate();
    const defaultTo = moment().set({ hour: 11, minute: 59 }).toDate();

    const [formData, setFormData] = useState({
        "user_id": user_id ? user_id : userInfo._id,
        "type": "0",
        "from_date": defaultFrom,
        "to_date": defaultTo,
        "game_type": "All",
    });

    // Format for display: dd:mm:yyyy
    // const formattedFromDate = formData.from_date ? moment(formData.from_date).format('DD:MM:YYYY HH:mm') : '';
    // const formattedToDate = formData.to_date ? moment(formData.to_date).format('DD:MM:YYYY HH:mm') : '';

    const defaultFromDayjs = dayjs(defaultFrom);
    const defaultToDayjs = dayjs(defaultTo);

    let locale = {
        emptyText: 'No data!',
    };
    const columns = [
        {
            title: 'Date/Time',
            dataIndex: 'createdAt',
            sorter: true,
            render: (_, record) => (
                <span className='font-extrabold text-[#212529] text-[0.813rem] '>{new Date(record.createdAt).toLocaleString()}</span>
            ),
        },
        {
            title: 'Deposit',
            dataIndex: 'amount',
            sorter: true,
            render: (_, record) => (
                record.transaction_type === "Credit" ?
                    <span className='font-extrabold text-[#508d0e] text-[0.813rem]'>{Number(record.amount).toFixed(2)}</span>
                    : '-'
            ),
        },
        {
            title: 'Withdraw',
            dataIndex: 'name',
            sorter: true,
            render: (_, record) => (
                record.transaction_type === "Debit" ?
                    <span className='font-extrabold text-[#d50000] text-[0.813rem]'>{Number(record.amount).toFixed(2)}</span>
                    : '-'
            ),
        },
        {
            title: 'Balance',
            dataIndex: 'balance',
            sorter: true,
            render: (_, record) => (
                <span className='font-extrabold text-[#212529] text-[0.813rem] '>{Number(record.balance).toFixed(2)}</span>
            ),
        },
        {
            title: 'Remarks',
            dataIndex: 'remarks',
            sorter: true,
            render: (_, record) => (
                <span className='font-extrabold text-[#212529] text-[0.813rem] '>{record.remarks}</span>
            ),
        },
        {
            title: 'From/To',
            sorter: true,
            render: (_, record) => (
                <span className='font-extrabold text-[#212529] text-[0.813rem] flex items-center justify-center'>
                    {record.from}
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="black" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9 17V7L16 12L9 17Z" />
                    </svg>
                    {record.to}
                </span>
            ),
        },
    ];
    const [data, setData] = useState([])
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    const handlePageSizeChange = (e) => {
        setPageSize(e);
        setCurrent(1);
    };

    const handleFirst = () => setCurrent(1);
    const handleLast = () => setCurrent(Math.ceil(data.length / pageSize));

    const startIndex = (current - 1) * pageSize;
    const endIndex = Math.min(startIndex + pageSize, data.length);
    const paginatedData = data?.slice(startIndex, endIndex);

    const filterAccountStatement = async () => {
        // Format dates for API as 'YYYY-MM-DD HH:mm'
        const apiFormData = {
            ...formData,
            from_date: moment(formData.from_date).format('YYYY-MM-DD HH:mm'),
            to_date: moment(formData.to_date).format('YYYY-MM-DD HH:mm'),
        };

        var dataStr = JSON.stringify(apiFormData);
        var config = {
            method: 'post',
            url: `${Appconfig.apiUrl}reports/aurafilteraccountStatement`,
            headers: {
                'Content-Type': 'application/json'
            },
            data: dataStr
        };

        axios(config)
            .then(function (response) {
                setData(response.data.resultData);
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    useEffect(() => {
        filterAccountStatement();
        // eslint-disable-next-line
    }, [])

    const onChangeDataType = (datatype) => {
        if (datatype === "LIVE") {
            setFormData({
                ...formData,
                from_date: moment().set({ hour: 11, minute: 59, second: 0, millisecond: 0 }).toDate()
            })
        } else if (datatype === "BACKUP") {
            setFormData({
                ...formData,
                from_date: moment().subtract(3, 'month').set({ hour: 11, minute: 59, second: 0, millisecond: 0 }).toDate()
            })
        } else if (datatype === "OLD") {
            setFormData({
                ...formData,
                from_date: moment().subtract(1, 'year').set({ hour: 11, minute: 59, second: 0, millisecond: 0 }).toDate()
            })
        }
    }

    return (
        <div className='grid grid-cols-12 '>
            <div className='col-span-12  mb-[1.5rem] lg:mb-[0px]'>
                <div className=' flex-[0_0_auto] w-full'>
                    <div className='lg:mb-[24px] rounded-[.25rem]  lg:pb-[0] w-full bg-[#e0e6e6]  text-[#212529] [word-wrap:break-word] border-[1px] border-[#000501] '>
                        <div className='!p-0 flex-auto'>
                            <div className='flex flex-wrap px-[10px] pt-[8px] lg:px-[10px]'>
                                {/* Data Source Dropdown (optional) */}
                                {/* ... */}

                                {/* <div className='lg:px-[12px] mb-[.2rem]   lg:!mb-4 flex-[0_0_auto] w-[100%] lg:w-[25%]'>
                                    <div className='relative flex flex-wrap items-stretch '>
                                        <div className='block w-full  text-[.875rem] font-normal leading-normal text-[#5c6873] rounded-[.25rem] [transition:border-color_.15s_ease-in-out,_box-shadow_.15s_ease-in-out] relative flex-auto !p-0 !bg-[#e5e7ea] !border-[none]'>
                                            <label className='inline-block mb-[.5rem] text-[0.813rem] font-normal leading-normal text-[#212529]'>From</label>
                                            <div className='!border-[1px] !border-[solid] !border-[#cccccc] relative table [border-spacing:0] bg-[#fff] rounded-[.25rem]'>
                                                <LocalizationProvider dateAdapter={AdapterMoment}>
                                                    <DatePicker
                                                        selected={formData.from_date}
                                                        onChange={date => setFormData({ ...formData, from_date: date })}
                                                        showTimeSelect
                                                        timeFormat="HH:mm"
                                                        timeIntervals={1}
                                                        dateFormat="dd:MM:yyyy HH:mm"
                                                        className="cursor-pointer flex items-center h-[34px] border-none text-[14px] !bg-[#e5e7ea] w-full outline-none rounded-[.25rem] overflow-hidden overflow-ellipsis whitespace-nowrap pl-[6px] text-[#555]"
                                                        placeholderText="Select date"
                                                        popperPlacement="bottom"
                                                        popperClassName="z-[9999]"
                                                        timeCaption="Time"
                                                        showPopperArrow={false}
                                                    />
                                                </LocalizationProvider>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className='lg:px-[12px] lg:!mb-4 flex-[0_0_auto] w-[100%] lg:w-[25%]'>
                                    <div className='relative flex flex-wrap items-stretch '>
                                        <div className='block w-full  text-[.875rem] font-normal leading-normal text-[#5c6873] rounded-[.25rem] [transition:border-color_.15s_ease-in-out,_box-shadow_.15s_ease-in-out] relative flex-auto !p-0 !bg-[#e5e7ea] !border-[none]'>
                                            <label className='inline-block mt-[4px] lg:mt-[0px] mb-[.5rem] text-[0.813rem] font-normal leading-normal text-[#212529]'>To</label>
                                            <div className='!border-[1px] !border-[solid] !border-[#cccccc] relative table [border-spacing:0] bg-[#fff] rounded-[.25rem]'>
                                                <LocalizationProvider dateAdapter={AdapterMoment}>
                                                    <DatePicker
                                                        selected={formData.to_date}
                                                        onChange={date => setFormData({ ...formData, to_date: date })}
                                                        showTimeSelect
                                                        timeFormat="HH:mm"
                                                        timeIntervals={1}
                                                        dateFormat="dd:MM:yyyy HH:mm"
                                                        className="cursor-pointer flex items-center h-[34px] border-none text-[14px] !bg-[#e5e7ea] w-full outline-none rounded-[.25rem] overflow-hidden overflow-ellipsis whitespace-nowrap pl-[6px] text-[#555]"
                                                        placeholderText="Select date"
                                                        popperPlacement="bottom"
                                                        popperClassName="z-[9999]"
                                                        timeCaption="Time"
                                                        showPopperArrow={false}
                                                    />
                                                </LocalizationProvider>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}

                                <div className='col-span-12 mb-4'>
                                    <div className='w-full bg-[#e0e6e6] border  p-4 rounded'>

                                        {/* <label className='block mb-2 text-[0.813rem] text-[#212529] font-normal'>
                                        Select Date & Time Range
                                        </label> */}

                                        <div className="flex flex-wrap gap-4 items-end">
                                            {/* From */}
                                            <div className="flex-1 min-w-[150px]">
                                                <label className='block mb-1 text-[0.813rem] text-[#212529] font-normal'>From</label>
                                                <DatePicker
                                                showTime={{ format: 'HH:mm' }}
                                                format="DD-MM-YYYY HH:mm"
                                                value={dayjs(formData.from_date)}
                                                className="w-full"
                                                onChange={(date, dateString) =>
                                                    setFormData({ ...formData, from_date: dayjs(dateString, 'DD-MM-YYYY HH:mm').toDate() })
                                                }
                                                />
                                            </div>

                                            {/* To */}
                                            <div className="flex-1 min-w-[150px]">
                                                <label className='block mb-1 text-[0.813rem] text-[#212529] font-normal'>To</label>
                                                <DatePicker
                                                showTime={{ format: 'HH:mm' }}
                                                format="DD-MM-YYYY HH:mm"
                                                value={dayjs(formData.to_date)}
                                                className="w-full"
                                                onChange={(date, dateString) =>
                                                    setFormData({ ...formData, to_date: dayjs(dateString, 'DD-MM-YYYY HH:mm').toDate() })
                                                }
                                                />
                                            </div>

                                            {/* Button */}
                                            <div className="flex-none">
                                                <Button
                                                type="primary"
                                                onClick={filterAccountStatement}
                                                className='mt-[1.7rem] bg-[#0c9971]' // aligns with input heights nicely
                                                >
                                                Get Statement
                                                </Button>
                                            </div>
                                        </div>

                                    </div>
                                </div>


                                {/* <div className='lg:px-[12px] mb-[.4rem] lg:mb-[.4rem] flex items-center  lg:!mb-[10px] flex-[0_0_auto] w-[50%] lg:w-[25%]'>
                                    <button onClick={filterAccountStatement} type="button" className="mt-[13px] lg:mt-[0px] ml-[10px] lg:ml-[0px] font-bold !px-[10px] !py-[5px] !text-[.875rem] text-[#ffffff] bg-[#0c9971] border-[#cccccc] inline-block leading-normal text-center rounded-[.375rem]">
                                        <strong >Get Statement</strong>
                                    </button>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className='col-span-12 mb-[1.5rem]'>
                <div className=' flex-[0_0_auto] w-full max-w-full'>
                    <div className='border-r-[1px] border-r-[#c8ced3] border-l-[1px] border-l-[#c8ced3] mb-[24px]  relative flex flex-col min-w-[0] text-[#212529] [word-wrap:break-word] bg-[#fff] bg-clip-border border-[1px] border-[solid] border-[#0000002d] rounded-[.375rem]'>
                        <div className='bg-[#0c9971] text-[#ffffff] font-bold text-[0.938rem] px-[10px] py-[5px] [word-wrap:break-word]'>
                            <span className='text-[#ffffff] font-bold text-[0.938rem]  py-[5px] [word-wrap:break-word]'>Deposit & Withdraw</span>
                        </div>
                        <div className='p-[1.25rem] flex-auto '>
                            <Table
                                title={() => (
                                    <div className='grid grid-cols-12'>
                                        <div className='col-span-12 lg:col-span-6 flex items-center justify-center lg:justify-start '>
                                            <div className='text-[#333] lg:m-[.5rem] p-[.5rem] lg:p-[0px]'>
                                                <label>
                                                    Show
                                                    <Select defaultValue={10} onChange={handlePageSizeChange} className='pagesize-select mx-[5px]'>
                                                        <Select.Option value={10}>10</Select.Option>
                                                        <Select.Option value={25}>25</Select.Option>
                                                        <Select.Option value={50}>50</Select.Option>
                                                        <Select.Option value={100}>100</Select.Option>
                                                    </Select>
                                                    entries
                                                </label>
                                            </div>
                                        </div>
                                        <div className='col-span-12 lg:col-span-6 flex items-center justify-center lg:justify-end'>
                                            <div className='text-[#333] mb-[.5rem] lg:m-[.5rem]'>
                                                <label>
                                                    Search:
                                                    <Input
                                                        // onChange={e => handleSearch(e.target.value, 'name')}
                                                        style={{ width: 155, marginLeft: '5px' }}
                                                    />
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                locale={locale}
                                columns={columns}
                                className=' account-statement'
                                bordered
                                dataSource={paginatedData}
                                pagination={false}
                            />
                            <div className='grid grid-cols-12 items-center pt-[1.5rem] lg:pt-[.75rem] text-[#333]'>
                                <div className='col-span-12 lg:col-span-6 text-[#333] text-[0.813rem]'>
                                    Showing {startIndex + 1} to {endIndex} of {data.length} entries
                                </div>
                                <div className='col-span-12 lg:col-span-6 flex items-center justify-end  pt-[1rem] lg:pt-[0px] lg:mt-[0rem]'>
                                    <button className='text-[0.813rem] cursor-default text-[#666] border-[1px] border-[solid] border-[transparent] bg-transparent [box-shadow:none] box-border inline-block min-w-[1.5em] px-[1em] py-[.5em] ml-[2px] text-center no-underline rounded-[2px] cursor-pointer' type='button' onClick={handleFirst} style={{ marginRight: 8 }}>First</button>
                                    <Pagination
                                        current={current}
                                        pageSize={pageSize}
                                        total={data.length}
                                        onChange={(page) => setCurrent(page)}
                                        itemRender={(page, type, originalElement) => {
                                            if (type === 'prev') {
                                                return <button type='button' className='!cursor-pointer'>Previous</button>;
                                            }
                                            if (type === 'page') {
                                                return null;
                                            }
                                            if (type === 'next') {
                                                return <button type='button' className='!cursor-pointer'>Next</button>;
                                            }
                                            return originalElement;
                                        }}
                                        showSizeChanger={false}
                                    />
                                    <button className='text-[0.813rem] cursor-default text-[#666] border-[1px] border-[solid] border-[transparent] bg-transparent [box-shadow:none] box-border inline-block min-w-[1.5em] px-[1em] py-[.5em] ml-[2px] text-center no-underline rounded-[2px]  cursor-pointer' type='button' onClick={handleLast} style={{ marginLeft: 8 }}>Last</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AccountStatement;